/* eslint-disable */
import cloudrun from '../clients/httpcloudrun'

export const AddTemplate= async (tableid,templateid,isConfigured,phoneNumber,mobileNumber,template,plan) => {

    const payload={tableid,templateid,isConfigured,phoneNumber,mobileNumber,template,plan}
    const dbresponse = await cloudrun.post('/saveTemplate', {payload})
    return dbresponse;
}